import React from 'react';

const SVG = ({
  style = {},
  fill = '#006eaf',
  viewBox = '0 0 24 24',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g fill={fill} fill-rule="evenodd" > 
      <path d="M17.333 4H12v1.333h5.333v5.333h5.333v12H1.333V5.333H8V4H5.333v-.667a2 2 0 0 1 4 0V12a1.333 1.333 0 1 1-2.667 0V8H5.333v4a2.667 2.667 0 1 0 5.333 0V3.333a3.333 3.333 0 0 0-6.666 0V4H0v20h24V10.667zm1.333 5.333v-2.12l2.12 2.12z"/>
    </g> 
  </svg>
);
export default SVG;